import { EquipmentResponse } from '../../../../../store/equipments/equipments.types'
import {
  getMaxMiddleSequenceId,
} from '../../../../../store/trips/trips.utils'
import { TripPayload } from '../../../../../store/trips/trips.types'

export const addTrailer = (
  tripTasks: TripPayload[],
  equipment: EquipmentResponse
): TripPayload[] => {
  const maxSequenceId = Math.max(getMaxMiddleSequenceId(tripTasks), 0)

  // Get tractor ID from existing tractor hook/drop if available
  const tractorId = tripTasks.find((task) => task.type === 'HOOK_TRACTOR')?.tractorId ?? null

  return [
    {
      type: 'HOOK_TRAILER',
      tractorId,
      trailerId:
        equipment.equipmentId != null ? String(equipment.equipmentId) : null,
      name: equipment.unitNumber,
      address: equipment.address,
      startTime: '2025-01-21T04:34:36.237',
      estimatedTime: '2025-01-21T04:34:36.237',
      sequenceId: maxSequenceId + 1,
    },
    {
      type: 'DROP_TRAILER',
      tractorId,
      trailerId:
        equipment.equipmentId != null ? String(equipment.equipmentId) : null,
      name: equipment.unitNumber,
      address: equipment.address,
      startTime: '2025-01-21T04:34:36.237',
      estimatedTime: '2025-01-21T04:34:36.237',
      sequenceId: maxSequenceId + 10,
    },
  ]
}
